import { SearchableCombobox, TSearchable } from '@/components/base/combobox'
import { useCombobox } from '@/helpers/useCombobox'
import { Duration } from '@/types'
interface Props {
  value: string
  onChange: (value: TSearchable | null) => void
  invalid: boolean
}

interface MultiplierFieldItem {
  id: Duration
  name: string
}

const values: MultiplierFieldItem[] = [
  { id: Duration.Day, name: 'day' },
  { id: Duration.Hour, name: 'hour' },
  { id: Duration.Month, name: 'month' },
  { id: Duration.Year, name: 'year' },
]

export const Selector = ({ value, onChange, invalid }: Props) => {
  const { items } = useCombobox<MultiplierFieldItem>({
    pageInfo: undefined,
    querySelected: undefined,
    queryCollection: values,
    buildSearchable: item => item
  })

  return (
    <SearchableCombobox
      data={items}
      fetchMore={() => {}}
      includeBlank={false}
      invalid={invalid}
      loading={false}
      moreToFetch={false}
      refetch={() => { }}
      searchField=""
      value={items.find(d => d.id == value) || { id: value, name: value }}
      onChange={onChange}
    />
  )
}
